<template>
  <div>
      <el-container>
          <el-header>
              <el-tabs v-model="activeName" @tab-click="handleClick" >
                <el-tab-pane :label="$t('message.开放平台')" name="plat"></el-tab-pane>
                <!-- <el-tab-pane :label="$t('message.test')" name="test"></el-tab-pane> -->
                <el-tab-pane label="外部Api调用账号" name="ApiAccount"></el-tab-pane>
                <!-- <el-tab-pane label="默认外部字段" name="DefaultExternalField"></el-tab-pane> -->
                <!-- <el-tab-pane label="特殊外部字段" name="SpecialExternalField"></el-tab-pane> -->
                <!-- <el-tab-pane label="事件接口白名单" name="EventInterfaceWhiteList"></el-tab-pane> -->
            </el-tabs>
          </el-header>
          <el-main>
				<plat v-if="activeName=='plat'"></plat>
				<test v-if="activeName=='test'"></test>
                <ApiAccount v-if="activeName=='ApiAccount'"></ApiAccount>
                <!-- <DefaultExternalField v-if="activeName == 'DefaultExternalField'"></DefaultExternalField> -->
                <SpecialExternalField v-if="activeName == 'SpecialExternalField'"></SpecialExternalField>
                <EventInterfaceWhiteList v-if="activeName == 'EventInterfaceWhiteList'"></EventInterfaceWhiteList>
          </el-main>
      </el-container>
  </div>
</template>

<script>
import plat from './plat.vue'
import test from './test.vue'
import ApiAccount from './ApiAccount.vue'
import DefaultExternalField from './DefaultExternalField.vue'
import SpecialExternalField from './SpecialExternalField.vue'
import EventInterfaceWhiteList from './EventInterfaceWhiteList.vue'
export default {
    name:'enterpriseSettings',
    components:{
        plat,
        test,
        ApiAccount,
        DefaultExternalField,
        SpecialExternalField,
        EventInterfaceWhiteList,
    },
    data(){
        return{
            activeName:'ApiAccount',
            oldName:''
        }
    },
    methods:{
        handleClick(tab, event) {
            this.activeName=tab.name
            if(this.oldName!=tab.name){
                // this.$route.push('/enterpriseSettings/'+tab.name)
            }
            this.oldName=tab.name
      }
    }
}
</script>

<style scoped>
    .cot .el-header{
        height: 6vh;
    }
    .cot .el-main{
        height: 70vh;
        /* background-color: #ccc; */
        /* background-color: blue; */
    }
    .cot .el-footer{
        height: 6vh;
        /* background-color: red; */
    }
</style>


// WEBPACK FOOTER //
// src/pages/settings/enterpriseSettings.vue